import React, { useEffect, useRef, useState } from "react";
import { Button, Table, Modal, Form, InputGroup } from "react-bootstrap";
import { FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import {
  deleteFAQById,
  fetchFAQsList,
  getFAQsByCategoryId,
  restoreFAQ,
  toggleFAQStatus,
} from "../../services/axios/apiManager";
import AddEditFaqModal from "./addEditFaqModal";
import FaqDetailsModal from "./faqDetails";
import BSPagination from "../../Components/pagination";
import LoadingSpinner from "../../Components/spinner";
import { toast } from "sonner";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const FaqsList = ({
  faqs,
  setFaqs,
  faqCategories,
  pagination,
  setPagination,
  granted,
}) => {
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  const [selectedFAQ, setSelectedFaq] = useState({});
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [query, setQuery] = useState("");
  const [faqForDetails, setFaqForDetails] = useState({});
  const [showDetailModal, setShowDetailmodal] = useState(false);
  const [filters, setFilters] = useState("3");
  const [filtering, setFiltering] = useState(false);
  const tableRef = useRef(null);

  // // // fetch Permissions with pagination
  const fetchFaqs = async (pgntn, str = "") => {
    setFiltering(true);
    const response = await fetchFAQsList(
      pgntn.currentPage || 1,
      pgntn.pageSize || 20,
      str
    );
    if (response?.data?.data) {
      setFaqs(response.data.data);
    }
    if (response?.data?.pagination) {
      setPagination(response.data.pagination);
    }
    setFiltering(false);
  };

  // // // Handle Pagination
  const handlePageChange = async (page) => {
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    const str = `status=${filters}`;
    fetchFaqs(temp, str);
  };

  // // // Reset all filters to default
  const resetFilters = async () => {
    setFilters(3);
    setQuery("");
    await fetchFaqs(pagination);
  };

  // // // Filters Logic
  // // // status = 0-Inactive, 1-Active, 2-deleted, 3 default
  const fetchFilteredFaqs = async (e) => {
    setQuery("");
    setFilters(e.target.value);
    const string = `status=${e.target.value}`;
    await fetchFaqs(pagination, string);
  };

  // // //Add Edit modal Logic
  const handleOpenAddEditModal = (faq) => {
    setSelectedFaq(faq);
    setShowAddEditModal(true);
  };

  const handleCloseAddEditModal = () => {
    setSelectedFaq({});
    setShowAddEditModal(false);
  };

  // // //Search FAQ logic
  const handleSearch = async (e) => {
    const string = e.target.value;
    setQuery(string);
    if (string.length > 0) {
      const results = await getFAQsByCategoryId(string);
      if (results?.data?.data) {
        setFaqs(results.data.data);
      }
      if (results?.data?.pagination) {
        setPagination(results.data.pagination);
      }
    } else {
      const str = `status=${filters}`;
      await fetchFaqs(pagination, str);
    }
  };

  // // // Change status Logic
  const handleStatusChange = async (faq) => {
    if (!granted?.some((g) => g.type === "toggle-status")) {
      toast.error(
        "You don't have neccessary permissions to do this operation!",
        {
          duration: 3000,
        }
      );
      return;
    }
    if (faq?.deletedAt === null) {
      setModalOptions({
        header: "Change Status",
        body: `Are you sure you want to change the status of "${faq.question}"?`,
        okay: "Change",
        method: changeStatus,
        data: { id: faq.id, status: faq.status === 1 ? 0 : 1 },
      });
      setShowOptionsModal(true);
    } else {
      toast.info("Cannot change status of a deleted record!", {
        duration: 2000,
      });
    }
  };

  const changeStatus = async (data) => {
    const response = await toggleFAQStatus(data);
    if (response?.data?.success === true) {
      const str = `status=${filters}`;
      await fetchFaqs(pagination, str);
      toast.info("FAQ status has been updated!", {
        duration: 2000,
      });
    }
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // //Delete Logic
  const handleDeleteFAQ = (faq) => {
    setModalOptions({
      header: "Delete FAQ",
      body: `Are you sure you want to delete "${faq.question}"?`,
      okay: "Delete",
      method: deleteFAQ,
      data: { id: faq.id },
    });
    setShowOptionsModal(true);
  };

  const deleteFAQ = async (data) => {
    if (data.id) {
      const response = await deleteFAQById(data.id);
      if (response?.data?.success && response?.data?.data === 1) {
        const str = `status=${filters}`;
        await fetchFaqs(pagination, str);
        toast.info("FAQ record has been deleted!", {
        duration: 2000,
      });
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  // // //Restore Logic
  const handleRestoreFAQ = (faq) => {
    setModalOptions({
      header: "Restore FAQ",
      body: `Are you sure you want to restore "${faq.question}"?`,
      okay: "Restore",
      method: restoreFAQById,
      data: { id: faq.id },
    });
    setShowOptionsModal(true);
  };

  const restoreFAQById = async (data) => {
    if (data.id) {
      const response = await restoreFAQ(data.id);
      if (response?.data?.success && response?.data?.data === 1) {
        const str = `status=${filters}`;
        await fetchFaqs(pagination, str);
        toast.info("FAQ record has been restored!", {
        duration: 2000,
      });
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };

  const openDetailModal = (faq) => {
    setFaqForDetails(faq);
    setShowDetailmodal(true);
  };

  useEffect(() => {
    const rows = faqs.map((f) => [
      f.faq_category?.title || "",
      f.question,
      f.answer,
      f.status === 1 ? "Active" : "Inactive",
      "", // placeholder for actions
    ]);

    const config = {
      data: rows,
      columns: [
        { title: "Category" },
        { title: "Question" },
        { title: "Answer" },
        { title: "Status", orderable: false },
        { title: "Actions", orderable: false },
      ],
      destroy: true,
      paging: false,
      searching: false,
      info: false,
      responsive: true,
      createdRow: (row, data, idx) => {
        const faq = faqs[idx];
        // status toggle
        const $status = $(
          `<button class="btn btn-link p-0 ${
            faq.status === 1 ? "text-success" : "text-danger"
          }" title="change status">${data[3]}</button>`
        ).on("click", () => handleStatusChange(faq));
        $("td", row).eq(3).empty().append($status);

        // actions
        const $act = $("td", row).eq(4).empty().css("display", "flex");
        // view
        if (filters !== "2") {
          $act.append(
            $(
              `<button class="btn btn-outline-success btn-sm me-1" title="view details"><i class="fa fa-eye"></i></button>`
            ).on("click", () => openDetailModal(faq))
          );
          // edit
          if (granted?.some((p) => p.type === "update")) {
            $act.append(
              $(
                `<button class="btn btn-outline-primary btn-sm me-1" title="edit"><i class="fa fa-edit"></i></button>`
              ).on("click", () => handleOpenAddEditModal(faq))
            );
          }
          // delete
          if (granted?.some((p) => p.type === "delete") && faq.status === 0) {
            $act.append(
              $(
                `<button class="btn btn-outline-danger btn-sm" title="delete"><i class="fa fa-trash"></i></button>`
              ).on("click", () => handleDeleteFAQ(faq))
            );
          }
        } else {
          $act.append(
            $(
              `<button class="btn btn-outline-danger btn-sm" title="restore"><i class="fa-solid fa-rotate-right"></i></button>`
            ).on("click", () => handleRestoreFAQ(faq))
          );
        }
      },
    };

    const $tbl = $(tableRef.current);
    if ($.fn.dataTable.isDataTable($tbl)) {
      $tbl.DataTable().clear().rows.add(rows).draw();
    } else {
      $tbl.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable($tbl)) $tbl.DataTable().destroy();
    };
  }, [faqs, granted]);

  return (
    <div className="container  text-light bg-dark rounded mb-4">
      <main className="flex-fill overflow-auto">
        <h3 className="text-light mt-2">FAQ's</h3>
        <div className="row align-items-center mb-4">
          <div className="col-md-8 row">
            <div className="col-md-5">
              <InputGroup className="mb-3">
                <Form.Select
                  type="text"
                  placeholder="Search FAQs by category..."
                  value={query}
                  onChange={handleSearch}
                  className="bg-dark text-light border-light input-placeholder-light"
                >
                  <option value="">All FAQ's</option>
                  {faqCategories?.map((c) => (
                    <option value={c.id}>{c.title}</option>
                  ))}
                </Form.Select>
              </InputGroup>
            </div>
            <div className="col-md-5">
              <InputGroup className="mb-3">
                <Form.Select
                  type="text"
                  placeholder="Search FAQs by category..."
                  value={filters}
                  onChange={(e) => {
                    fetchFilteredFaqs(e);
                  }}
                  className="bg-dark text-light border-light input-placeholder-light"
                >
                  <option value="3">Active & Inactive</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                  <option className="text-danger" value="2">
                    Deleted
                  </option>
                </Form.Select>
              </InputGroup>
            </div>
            <div className="col-md-1">
              {filtering ? (
                <LoadingSpinner size={"md"} />
              ) : (
                <div className="row ">
                  <Button
                    title="Reset Filters And Rrfresh Records"
                    className="btn btn-success"
                    onClick={() => {
                      resetFilters();
                    }}
                  >
                    Reset
                  </Button>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-4 text-end">
            {granted?.some((g) => g.type === "create") && (
              <Button
                title="Add New FAQ"
                variant="success"
                className="mb-3 d-flex"
                onClick={() => handleOpenAddEditModal({})}
                style={{ float: "right" }}
              >
                Add New FAQ
              </Button>
            )}
          </div>
        </div>
        <div className="table-responsive">
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped w-100"
            />
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-end mt-2">
            <div className="mx-4 py-2">
            <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
          </div>
            <BSPagination
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              onPageChange={handlePageChange}
              siblingCount={2}
              showFirstLast
            />
          </div>
        </div>
        {/* /////////////////Add/Edit Modal/////////////// */}
        <AddEditFaqModal
          handleCloseAddEditModal={handleCloseAddEditModal}
          showAddEditModal={showAddEditModal}
          setSelectedFaq={setSelectedFaq}
          faqCategories={faqCategories}
          selectedFAQ={selectedFAQ}
          setFaqs={setFaqs}
        />
        {/* /////////////////Details Modal/////////////// */}
        <FaqDetailsModal
          faqForDetails={faqForDetails}
          showDetailModal={showDetailModal}
          setShowDetailmodal={setShowDetailmodal}
          setFaqForDetails={setFaqForDetails}
        />
        {/* /////////////////Options Modal/////////////// */}
        <Modal
          show={showOptionsModal}
          onHide={handleCloseOptionsModal}
          centered
          className="text-light"
        >
          <Modal.Header closeButton className="bg-dark text-light border-0">
            <Modal.Title>{modalOptions.header}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-dark text-light">
            {modalOptions.body}
          </Modal.Body>
          <Modal.Footer className="bg-dark text-light border-0">
            <Button variant="secondary" onClick={handleCloseOptionsModal}>
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                modalOptions.method(modalOptions.data);
              }}
            >
              {modalOptions.okay}
            </Button>
          </Modal.Footer>
        </Modal>
      </main>
    </div>
  );
};

export default FaqsList;
